<template>
    <div class="content">
        <div class="top-box">
            <div class="btn btn-home" @click="toHome">数据概览</div>
            <div class="btn btn-device">设备管理</div>
            <div class="btn btn-patient" @click="toUser">患者管理</div>
            <div class="btn-active btn-data" @click="toData">手表数据</div>
            <div class="btn-admin"></div>
            <img class="btn-icon" src="@/assets/home/04icon.png">
            <div class="user-name" @click="toAdmin">{{ loginName }}</div>
            <div class="time-box">{{ time }}</div>
        </div>
        <div class="main">
            <el-form :inline="true" label-position="top" size="mini">
                <el-form-item label="设备型号">
                    <el-cascader :options="watchModel" :props="{ expandTrigger: 'hover', emitPath: false }"
                                 v-model="watchType" placeholder="请选择设备型号" :show-all-levels="false"
                                 clearable></el-cascader>
                </el-form-item>
                <el-form-item label="MAC">
                    <el-input v-model="mac" placeholder="请输入MAC"></el-input>
                </el-form-item>
                <el-form-item label="患者关键字">
                    <el-input v-model="userKey" placeholder="可输入患者Id/姓名"></el-input>
                </el-form-item>
                <el-form-item label="创建时间">
                    <el-date-picker
                        v-model="bindTime"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div class="btn-box">
                <div>
                    <el-button type="info" @click="reset" size="mini">重置</el-button>
                    <el-button type="primary" @click="search" size="mini">查询</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                stripe
                border
                style="width: 100%"
            >
                <el-table-column
                    prop="id"
                    label="id"
                    width="100"
                >
                </el-table-column>
                <el-table-column
                    prop="userId"
                    label="患者id"
                >
                </el-table-column>
                <el-table-column
                    prop="userName"
                    label="姓名"
                >
                </el-table-column>
                <el-table-column
                    prop="watchName"
                    label="手表型号"
                >
                </el-table-column>
                <el-table-column
                    prop="watchVersion"
                    label="固件版本"
                >
                </el-table-column>
                <el-table-column
                    prop="logType"
                    label="日志类型"
                >
                </el-table-column>
                <el-table-column
                    prop="logFileName"
                    label="文件名"
                >
                </el-table-column>
                <el-table-column
                    prop="logFile"
                    label="日志文件"
                >
                    <template slot-scope="scope">
                        <div slot="reference" class="name-wrapper">
                            <el-link type="primary" :href="scope.row.logFile" target="_self">点击下载</el-link>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="logDesc"
                    label="描述"
                >
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    label="创建时间"
                >
                </el-table-column>
            </el-table>
            <div style="margin-top: 15px">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNum"
                    :page-sizes="[20, 30, 40, 50]"
                    :page-size="20"
                    layout="prev, pager, next, sizes, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import * as XLSX from 'xlsx';
import {getCommonLogList} from "../../api/data";

export default {
    name: 'index',
    data() {
        return {
            loginName:localStorage.getItem("phone"),
            time: '',
            mac: '',
            userKey: '',
            watchType: '',
            deviceType: '',
            logType: '',
            bindTime: '',
            isBind: '',
            watchModel: [],
            tableData: [],
            total: 0,
            pageNum: 1,
            pageSize: 20,
            tableSelection: '',
            addVisible: false,
            device: {
                watchType: '',
                bleMac: '',
                sn: '',
                phone: '',
                version: ''
            },
            importTag: false,
            excelData: []
        }
    },
    mounted() {
        this.startTimer();
        this.getWatchModelList();
        this.search()
    },
    methods: {
        toHome() {
            this.$router.push({
                path: '/home',
            })
        },
        toUser() {
            this.$router.push({
                name: 'user'
            })
        },
        toData() {
            this.$router.push({
                name: 'data'
            })
        },
        toAdmin() {
            this.$router.push({path: '/admin'});
        },
        getTime() {
            let time = new Date();
            let year = time.getFullYear();
            let month = (time.getMonth() + 1).toString().padStart(2, '0');
            let day = time.getDate().toString().padStart(2, '0');
            let hour = time.getHours().toString().padStart(2, '0');
            let minute = time.getMinutes().toString().padStart(2, '0');
            let second = time.getSeconds().toString().padStart(2, '0');
            this.time = year + '/' + month + '/' + day + '\n' + hour + ':' + minute + ':' + second;
            this.latestTime = this.time
        },
        startTimer() {
            // 立即执行一次
            this.getTime();
            // 每秒执行一次
            setInterval(() => {
                this.getTime();
            }, 1000);
        },
        getWatchModelList() {
            this.$api.device.getWatchModelList({
                pageNum: 1,
                pageSize: 200
            }).then(res => {
                let data = res.data.items
                this.watchModel = [];
                for (let i = 0; i < data.length; i++) {
                    let modelList = data[i].model.split(',');
                    let type = {
                        value: data[i].type,
                        label: data[i].type,
                        children: []
                    };
                    for (let j = 0; j < modelList.length; j++) {
                        let model = {
                            value: modelList[j],
                            label: modelList[j]
                        };
                        type.children.push(model)
                    }
                    this.watchModel.push(type);
                }
            })
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.search();
        },
        handleCurrentChange(val) {
            this.pageNum = val;
            this.search();
        },
        search() {
            this.$api.data.getCommonLogList({
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                mac: this.mac,
                userKey: this.userKey,
                watchType: this.watchType,
                logType: this.logType,
                startDate: this.bindTime[0],
                endDate: this.bindTime[1]
            }).then(response => {
                this.tableData = response.data.items;
                this.total = response.data.count;
                if (this.total != 0 && this.tableData.length == 0) {
                    this.pageNum = 1;
                    this.search()
                }
            })
        },
        reset() {
            this.mac = '';
            this.userKey = '';
            this.watchType = '';
            this.bindTime = '';
            this.search();
        },
    }
}
</script>

<style scoped>
.content {
    width: 1920px;
    height: 1080px;
    background-color: #0A192F;
    background-image: url("~@/assets/home/01bg.png");
    background-size: cover;
    box-sizing: border-box;
    overflow-x: hidden;
    font-size: 14px;
}

.main {
    width: 1728px;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 0px 0px 0px 0px;
    margin: 0 auto;
    padding: 38px 53px 20px 32px;
    font-size: 14px;
}

/deep/ .el-input__inner {
    background-color: rgba(0, 111, 255, 0.1);
    color: #ffffff;
    border: 1px solid rgba(0, 136, 255, 0.6);
}

/deep/ .el-cascader__dropdown {
    background: rgba(0, 111, 255, 0.1);
}

/deep/ .el-range-input {
    background-color: rgba(0, 111, 255, 0.1);
    color: #ffffff;
}

/deep/ i {
    font-size: 12px;
}

.btn-box {
    display: flex;
    justify-content: space-between;
    margin-bottom: 32px;
}

.table-btn {
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
}

.table-btn0 {
    color: #0088FF;
}

.table-btn1 {
    color: #1CB9FF;
}

.table-btn2 {
    color: #FF3A62;
}

/deep/ .el-table {
    height: 600px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/data/index.vue